import { apiFetch } from "./auth";

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);

  // IMPORTANT: ne pas mettre Content-Type ici, fetch le gère pour FormData
  const res = await apiFetch("/api/uploads/image", {
    method: "POST",
    headers: {}, 
    body: form,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "Erreur upload");
  return { url: data.url, publicId: data.publicId };
}
